// src/pages/admin/adminRoutes.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isAdminAuthed } from "../../utils/auth.js";

/** Protects admin layout: redirects to /admin/signin when not logged in. */
export function RequireAdminAuth({ children }) {
  const location = useLocation();
  if (!isAdminAuthed()) {
    return (
      <Navigate
        to="/admin/signin"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }
  return children;
}
